import { FC } from "react"
import Logo from "./Logo";

type TopBarProps = {
  children?: React.ReactNode;
};

const TopBar: FC<TopBarProps> = ({ children }) => {
  // TODO: "out of order" version. Use the commit 3f589d91 to restore the original functional version.
  return (
    <div className="h-16 relative flex items-center w-full">
      <Logo />
      <div className="absolute left-1/2 -translate-x-1/2">
        <h1 className="font-center-light text-xl">{children}</h1>
      </div>
      <div className="mr-5">
      </div>
    </div>
  )
}

export default TopBar